import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { rowsPerPageOptions } from "utils/constants";

const useUserOrdersFilters = () => {
	const [filters, setFilters] = useState({
		page: 1,
		rowsPerPage: rowsPerPageOptions[0],
		search: "",
	});

	const { replace } = useHistory();
	const { pathname, search } = useLocation();

	// Initialize filters from URL params on mount
	useEffect(() => {
		const urlParams = new URLSearchParams(search);
		const page = parseInt(urlParams.get("page")) || 1;
		const rowsPerPage =
			parseInt(urlParams.get("rows_per_page")) || rowsPerPageOptions[0];
		const searchTerm = urlParams.get("search") || "";

		setFilters({
			page,
			rowsPerPage,
			search: searchTerm,
		});
	}, [search]);

	const updateFilters = (newFilters) => {
		const updatedFilters = { ...filters, ...newFilters };
		setFilters(updatedFilters);

		// Update URL with new filters
		const urlParams = new URLSearchParams();
		if (updatedFilters.page > 1) {
			urlParams.set("page", updatedFilters.page.toString());
		}
		if (updatedFilters.rowsPerPage !== rowsPerPageOptions[0]) {
			urlParams.set("rows_per_page", updatedFilters.rowsPerPage.toString());
		}
		if (updatedFilters.search) {
			urlParams.set("search", updatedFilters.search);
		}

		const newUrl = urlParams.toString()
			? `${pathname}?${urlParams.toString()}`
			: pathname;
		replace(newUrl);
	};

	const resetFilters = () => {
		const defaultFilters = {
			page: 1,
			rowsPerPage: rowsPerPageOptions[0],
			search: "",
		};
		setFilters(defaultFilters);
		replace(pathname); // Clear URL params
	};

	const clearSearch = () => {
		updateFilters({ search: "", page: 1 });
	};

	// Reset to page 1 when search changes
	useEffect(() => {
		if (filters.search !== "") {
			setFilters((prev) => ({ ...prev, page: 1 }));
		}
	}, [filters.search]);

	return {
		filters,
		updateFilters,
		resetFilters,
		clearSearch,
	};
};

export default useUserOrdersFilters;
